<template>
    <div class="edit main" style="padding-bottom: 40px">
      <div v-if="detailObj.kkProductUpdated" class="update-alert f--c">
        <i class="el-icon-warning"></i>
        <div style="margin: 0 10px;">{{ $t('publishEdit.tips9') }}</div>
        <div style="color:#9AC331" class="pointer" @click="update">{{ $t('publishEdit.Update') }}</div>
      </div>
        <div class="f-b top" style="height: 64px">
            <div>
                <div class="breadcrumb">
                    <el-breadcrumb separator="<">
                        <el-breadcrumb-item class="fontfine" :to="{ path: '/publish/listings' }">{{ $t('publishEdit.listings') }}</el-breadcrumb-item>
                        <el-breadcrumb-item><a >{{ $t('publishEdit.ProductionEditor')}}</a></el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <p class="ProductionEditor">{{ $t('publishEdit.ProductionEditor')}}</p>
            </div>
            <div class="buttonGroupTop f--c">
                <el-button size="middle" @click="$router.push('/publish/listings')">{{ $t('publishEdit.CancelEditing')}}</el-button>
            </div>
        </div>
        <TopInfo :imageUrl="imageUrl" :detailObj="detailObj" :submitMode="submitMode" ref="TopInfo" :platformCode="getDetailParams.platformCode"></TopInfo>
        <div class="f" style="margin-top: 10px">
            <el-radio-group v-model="radio1">
                <el-radio-button :label="$t('Publish.Edit.Index.Description')"><span class="requiredLabel">{{$t('publishEdit.Description')}}</span></el-radio-button>
                <el-radio-button :label="$t('Publish.Edit.Index.Variants')"><span class="requiredLabel">{{$t('publishEdit.Variants')}}</span></el-radio-button>
                <el-radio-button :label="$t('Publish.Edit.Index.Images')"><span class="requiredLabel">{{$t('publishEdit.Images')}}</span></el-radio-button>
            </el-radio-group>
        </div>
        <div style="background-color: #ffffff;padding: 16px;" v-cloak>
            <div v-if="radio1 === $t('Publish.Edit.Index.Description')" >
              <div class="f--c">
                <div style="margin-right:10px">{{ $t('Publish.Edit.Index.SizeUnit') }}:</div>
                <!-- <el-radio-group v-model="sizeUnit" @change="sizeUnitChange">
                  <el-radio :label="'inch'">inch</el-radio>
                  <el-radio :label="'cm'">cm</el-radio>
                </el-radio-group> -->
                <el-checkbox-group v-model="sizeUnit" @change="sizeUnitChange">
                  <el-checkbox value="inch" label="inch" />
                  <el-checkbox value="cm" label="cm" />
                </el-checkbox-group>
              </div>
              <img v-if="detailObj.sizeChartImageUrl" :src="detailObj.sizeChartImageUrl" alt="" style="max-width:1150px" />
              <RichTextEditor :content="detailObj" ref="RichTextEditor"></RichTextEditor>
              <div style="margin: 20px 0;">
                  <!-- <div>- {{ $t('publishEdit.tips1') }}</div> -->
                  <div>- {{ $t('publishEdit.tips2') }}</div>
              </div>
            </div>
            <Variants
              :detailObj="detailObj"
              :imageList="imageList"
              :storeSettings="storeSettings"
              v-show="radio1 === $t('Publish.Edit.Index.Variants')"
              @changeImageUrl="changeImageUrl"
              ref="Variants"
              :submitMode="submitMode"
              :getDetailParams="getDetailParams"
              :sizeImagePath="sizeImagePath"
              :platformCode="getDetailParams.platformCode"></Variants>
            <imageList :imageList="imageList" ref="imageList" :radio1="radio1" :platformCode="getDetailParams.platformCode"></imageList>
        </div>
        <div class="buttonGroup f-c-c">
            <el-button type="primary" style="width: 320px" @click="listNowClick" >{{ $t('publishEdit.listNow') }}</el-button>
        </div>
    </div>
</template>
<script>
import API from '@/api'
import RichTextEditor from './components/RichTextEditor.vue'
import TopInfo from './components/TopInfo.vue'
import imageList from './components/imageList.vue'
import Variants from './components/Variants.vue'
import { languageMap } from '@/config/languageMap'
import _ from 'lodash'
import bus from '@/util/bus'

export default {
  name: 'edit',
  components: { RichTextEditor, TopInfo, imageList, Variants },
  data() {
    return {
      radio1: this.$t('Publish.Edit.Index.Description'),
      imageList: [],
      detailObj: {
        'productId': undefined,
        'kkProductId': undefined,
        'title': undefined,
        'bodyHtml': undefined,
        'listingStatus': undefined,
        'tags': undefined,
        'storeName': undefined,
        'variants': [],
        'options': [],
        'images': [],
        'id': undefined,
        'storeId': undefined,
        'listingId': undefined,
        'collectionId': undefined,
        'collectionName': undefined,
        'imageUrl': undefined,
        productType: undefined,
        ttWarehouseList: [] // TT平台仓库
      },
      getDetailParams: {
        listingStatus: undefined,
        isListingQueueStatusAndPublishFail: false, // 是否是从未刊登成功过状态  没有productId的编辑  说明还未刊登成功过  图片与sku还有关联
        platformCode: '',
        languageId: 1
      },
      submitMode: 'add',
      storeSettings: { currency: '' }, // 店铺设置信息，计算除原价外的价格用此规则
      imageUrl: '',
      sizeImagePath: '',
      // sizeUnit: 'inch',
      sizeUnit: ['inch'],
      bodyHtml: '', // 切换尺码拼接用
      loadingFullscreen: null
    }
  },
  created() {
    this.submitMode = this.$route.query.isEdit ? 'edit' : 'add'
    if (this.$route.query.platformCode === 'TT') {
      this.tiktokListingWarehouses()
    }
    if (this.submitMode === 'add') {
      if (!this.$route.query.kkProductId) return this.$message.error(this.$t('promptText.msg17'))
    }
    this.getDetail()
    bus.$on('skuChangeImageHandle', imageList => {
      this.imageList = imageList
    })
  },
  methods: {
    getStoreSetting() {
      return new Promise((resolve, reject) => {
        this.getDetailParams = this.$route.query
        this.getDetailParams.languageId = languageMap[this.$store.state.language] || 1
        API.publishGetStoreSetting({ storeId: this.getDetailParams.storeId }).then(res => {
          this.storeSettings = res.data
          this.getDetailParams.currency = this.storeSettings.currency
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    async getDetail() {
      await this.getStoreSetting()
      /*
          获取详情方式
          1根据kkProductId获取  从商品模块跳转过来  调新增接口
          2根据单id获取  从刊登listings条状过来    调编辑接口
        */
      const loading = this.$loading.service({ text: this.$t('publishEdit.loadingText') })
      if (this.submitMode === 'add') {
        try {
          let res = await API.publishGetListingProductDetail(this.getDetailParams)
          if (res.code !== 10000) this.$message.error(res.message)
          if (res.data) {
            this.detailObj = Object.assign(this.detailObj, res.data, this.getDetailParams)
            this.$nextTick(() => {
              this.$refs.Variants.addModeVariantsHandle(res.data.otherWareHouseSkus, this.detailObj)
              this.detailObj.requiresShipping = true
              this.detailObj.inventoryPolicy = false
              this.detailObj.taxable = !!this.storeSettings.isTax
              this.sizeImagePath = this.detailObj.sizeImagePath
            })
            this.bodyHtml = res.data.bodyHtml
            let unit = this.sizeUnit.join()
            let sizeContent = await API.productSizeContent({ kkProductId: this.detailObj.kkProductId, unit, image: this.getDetailParams.platformCode === 'TT' })
            if (sizeContent.code !== 10000) this.getSizeContentError(sizeContent.message)
            if (this.getDetailParams.platformCode === 'TT') {
              this.$set(this.detailObj, 'sizeChartImageUrl', sizeContent.data ? sizeContent.data.sizeContent : '')
              this.$refs.TopInfo.tiktokGetCategoryId()
            } else {
              if (this.detailObj.sizeInfo) this.detailObj.bodyHtml += this.detailObj.sizeInfo
              else this.detailObj.bodyHtml += sizeContent.data ? sizeContent.data.sizeContent : ''
            }
            if (+this.$route.query.updateProcessed === 2) {
              let updateData = JSON.parse(sessionStorage.getItem('listingUpdateData'))
              this.$set(this.$data, 'detailObj', { ...this.detailObj, ...updateData })
              this.$refs.TopInfo.handleTag(this.detailObj.tags)
            }
          }
        } catch (err) {
          let message = err.message || err.data.message
          this.$message.error(message)
        }
        loading.close()
      } else {
        let res
        try {
          if (!this.getDetailParams.platformCode) return
          switch (this.getDetailParams.platformCode) {
            case 'DJ':
              res = await API.shoplazzaListingDetail(this.getDetailParams)
              break
            case 'SP':
              res = await API.publishGetListingDetail(this.getDetailParams)
              break
            case 'SL':
              res = await API.shoplineGetDetail(this.getDetailParams)
              break
            case 'WC':
              res = await API.woocommerceGetDetail(this.getDetailParams)
              break
            case 'TT':
              res = await API.tiktokListingDetail(this.getDetailParams)
              res.data.title = res.data.productName
              res.data.variants = res.data.variants.map(t => ({
                ...t,
                sku: t.sellerSku
              }))
              res.data.images = res.data.images.map(t => ({
                ...t,
                src: t.imageUrl
              }))
              res.data.bodyHtml = res.data.description
              break
            default:
              res = await API.publishGetListingDetail(this.getDetailParams)
              break
          }
          if (res.code !== 10000) this.$message.error(res.message)
          if (!res.data) return
          this.detailObj = Object.assign(this.detailObj, res.data, this.getDetailParams)
          this.editModelHandle(this.detailObj.variants, this.imageList)
          this.bodyHtml = res.data.bodyHtml
          // this.sizeUnit = res.data.sizeUnit || 'inch'
          this.sizeUnit = res.data.sizeUnit ? res.data.sizeUnit.split(',') : ['inch']

          if (this.getDetailParams.platformCode !== 'TT') {
            if (this.detailObj.sizeInfo) this.detailObj.bodyHtml += this.detailObj.sizeInfo
            else {
              let sizeContent = await API.productSizeContent({ kkProductId: this.detailObj.kkProductId, unit: this.sizeUnit, image: this.getDetailParams.platformCode === 'TT' })
              if (sizeContent.code !== 10000) this.getSizeContentError(sizeContent.message)
              else this.detailObj.bodyHtml += sizeContent.data ? sizeContent.data.sizeContent : ''
            }
          } else {
            this.$refs.TopInfo.categoryId = this.detailObj.categoryId
            this.$refs.TopInfo.defaultAttributes(this.detailObj.productAttributes)
          }
        } catch (err) {
          // let message = err.message || err.data.message
          // this.$message.error(message)
        }
        loading.close()
      }
    },
    // 获取尺码接口失败 报错抛出
    getSizeContentError(message) {
      this.$message.error(message)
    },
    // 编辑才调用的方法  ListingQueue(队列中的状态) sku选中状态对应图片选中状态处理
    editModelHandle() {
      const { storeId } = this.$route.query
      // 如果没有productId  图片勾选状态为后端返回   有productId则默认全部勾选
      // ListingQueue(队列中的状态) sku选中状态对应图片选中状态处理
      // 如果选中对应图片也选中  没选中则取消勾选
      // 有productId说明刊登成功过
      this.getDetailParams.isListingQueueStatusAndPublishFail = !this.detailObj.productId
      this.imageList = this.detailObj.images || []
      this.imageUrl = this.detailObj.imageUrl
      this.$refs.Variants.EditfirstLoad()
      this.$refs.TopInfo.publishGetCollections(storeId, this.detailObj.categoryIds || undefined)
      // this.$refs.Variants.EditFirstLoadPublishGetWarehouseStock()
      // custom 默认为 produType
      this.$set(this.detailObj, 'custom', this.detailObj.produType)
      this.$refs.TopInfo.handleTag(this.detailObj.tags)
      this.detailObj.taxable = !!this.storeSettings.isTax
    },
    // 设置isChecked字段
    variantsSetIsChecked(params) {
      const selection = this.$refs.Variants.getSelection()
      params.data.variants.forEach(e => {
        e.isChecked = !!selection.find(s => s.id === e.id)
      })
    },
    // 获取提交参数
    getListNowParams() {
      let params = Object.assign({}, { data: JSON.parse(JSON.stringify(this.detailObj)) })
      // 调试用  图片position先设置为1
      if (this.submitMode === 'add') {
        params.data = Object.assign(params.data, this.getDetailParams)
        params.data.otherWareHouseSkus = undefined
        params.data.vendor = params.data.storeName
        const variants = this.$refs.Variants.getSelection()
        params.data.variants = variants
        if (this.getDetailParams.platformCode === 'DJ') {
          params.data.taxable = !!this.storeSettings.isTax
        }
      } else {
        params.data.synTypeList = params.data.productId ? [2] : [1]
        if (this.getDetailParams.platformCode === 'DJ') {
          params.data.description = params.data.bodyHtml
        }
      }
      this.variantsSetIsChecked(params)
      const mainImg = _.uniqBy(params.data.variants.map(e => ({ imgUrl: e.imageUrl, status: 1, isChecked: true, src: e.imageUrl, imageId: e.imageId })), 'imgUrl')
      const finalImgArr = []
      this.imageList.filter(e => e.isChecked).forEach(img => {
        if (img.imgUrl && mainImg.findIndex(e => e.imgUrl === img.imgUrl) !== -1) return
        finalImgArr.push(img)
      })
      if (this.getDetailParams.platformCode === 'TT' && this.submitMode === 'edit') {
        params.data.images = params.data.images.map(t => ({
          ...t,
          imgUrl: t.src
        }))
      } else if (this.submitMode === 'edit' && this.$route.query.updateProcessed !== 2) {
        params.data.images = [...finalImgArr]
      } else params.data.images = [...mainImg, ...finalImgArr]
      params.data.images.forEach((item, i) => {
        item.position = i + 1
      })
      if (this.getDetailParams.platformCode === 'SL') params.data.images = params.data.images.slice(0, 40)
      // 取店铺设置的币种
      params.data.currency = this.storeSettings.currency
      // 物流信息存储
      params.data.logistics = this.$refs.Variants.getlogistics()
      params.data.tags = this.$refs.TopInfo.getTags()
      params.data.imageUrl = this.imageUrl
      // 尺码存储
      params.data.sizeUnit = this.sizeUnit.length > 1 ? 'inch,cm' : this.sizeUnit.join()

      // collectionId 为数组是格式化
      if (Array.isArray(params.data.collectionId)) {
        params.data.collectionId = params.data.collectionId.join(',')
      }

      if (params.data.variants.some(e => !e.sku)) {
        this.$message.error(this.$t('publishEdit.tips6'))
        return
      }

      // tab校验跳转
      this.tabDecision()
      // 开始校验
      if (!params.data.title) {
        this.$message.error(this.$t('publishEdit.titleCheck'))
        return false
      }
      if (!params.data.variants.some(e => e.isChecked)) {
        this.$message.error(this.$t('publishEdit.SKUCannotBeEmpty'))
        return false
      }
      if (!params.data.images || !params.data.images.length) {
        this.$message.error(this.$t('publishEdit.PictureCannotBeEmpty'))
        return false
      }
      if (params.data.images.length > 250) {
        this.$message.error(this.$t('publishEdit.imageMaxLengthTips'))
        return false
      }
      if (+_.get(params, 'data.bodyHtml.length', 0) === 0) {
        this.$message.error(this.$t('publishEdit.DescriptionCheck'))
        return false
      }
      // 对比价格为空 或者比销售价格大时通过   小于销售价格时拦截
      if (!params.data.variants.every(e => {
        if (typeof e.price !== 'number') {
          return false
        }
        if (e.compareAtPrice && typeof e.compareAtPrice === 'number') {
          let result = e.compareAtPrice > e.price
          if (this.getDetailParams.platformCode === 'DJ') {
            result = e.compareAtPrice > (e.price * (100 / 99.5))
          }
          return result
        }
        return true
      })) {
        this.$message.error(this.$t('publishEdit.CompareAtPriceCheck'))
        return false
      }
      params.data.variants.forEach(e => (e.cost = e.originalPrice))
      // Woocommerce
      /*
        变体字段调整  option 改为 attributes
      */
      if (this.getDetailParams.platformCode === 'WC') {
        // params.data.categoryIdsStr = this.$refs.TopInfo.categoryIds.join(', ')
        let categoryIdsStr = ''
        this.$refs.TopInfo.categoryIds.forEach(e => {
          categoryIdsStr += e[e.length - 1]
          categoryIdsStr += ','
        })
        categoryIdsStr = categoryIdsStr.slice(0, -1)
        params.data.categoryIdsStr = categoryIdsStr
        params.data.options.forEach(e => {
          e.options = e.values
        })
        if (this.submitMode === 'add') {
          params.data.attributes = params.data.options
          delete params.data.options
        }
        let tagsList = this.$refs.TopInfo.tagsList
        let tags = this.$refs.TopInfo.tagsValue.map(val => {
          let target = tagsList.find(e => e.name === val)
          if (target) return { id: target.tagId, name: val }
          return { name: val }
        })
        params.data.tags = tags
      }

      // TT 平台参数字段
      if (this.getDetailParams.platformCode === 'TT') {
        if (!this.$refs.TopInfo.categoryId) {
          this.$message.error(this.$t('publishEdit.categoryIdCheck'))
          return false
        }
        params.data.productName = params.data.title
        params.data.description = params.data.bodyHtml
        params.data.categoryId = this.$refs.TopInfo.categoryId
        if (this.$refs.TopInfo.tiktokAttributes.name && !this.$refs.TopInfo.productAttributes) {
          this.$message.error(this.$refs.TopInfo.tiktokAttributes.name + ' ' + this.$t('publishEdit.optionEmptyTip'))
          return false
        }
        if ((params.data.productAttributes && params.data.productAttributes.length) || this.$refs.TopInfo.productAttributes) {
          let arr = []
          if (this.$refs.TopInfo.productAttributes) {
            arr.push({
              id: this.$refs.TopInfo.tiktokAttributes.id,
              name: this.$refs.TopInfo.tiktokAttributes.name,
              values: this.$refs.TopInfo.tiktokAttributes.values.filter(t => t.id === this.$refs.TopInfo.productAttributes)
            })
          }
          params.data.productAttributes = arr
        }

        if (this.submitMode === 'add') {
          params.data.packageDimensions = {
            length: params.data.variants[0].packageLength,
            width: params.data.variants[0].packageWidth,
            height: params.data.variants[0].packageHeight,
            unit: 'CENTIMETER'
          }
          params.data.weight = {
            value: params.data.variants[0].packageWeight,
            unit: 'KILOGRAM'
          }
        }
        params.data.images = params.data.images.map(item => ({
          ...item,
          imageUrl: item.imgUrl
        }))
        if (params.data.images.length > 9) params.data.images.length = 9
        params.data.variants = params.data.variants.map(item => ({
          ...item,
          sellerSku: item.skuCode
        }))
      }
      return params
    },
    // 提交  刊登
    async listNowClick(filterDuplicateSpu = false) {
      const params = this.getListNowParams()
      if (!params) return
      delete params.data.ttWarehouseList
      if (filterDuplicateSpu === true) params.data.filterDuplicateSpu = false
      const loading = this.$loading.service()
      if (this.submitMode === 'add') {
        let res
        try {
          if (this.getDetailParams.platformCode === 'DJ') {
            if (+this.$route.query.updateProcessed === 2) {
              delete params.data.otherWareHouseSkus
              delete params.data.platformName
              res = await API.shoplazzaEdit(params)
            } else res = await API.shoplazzaAdd(params)
          } else if (this.getDetailParams.platformCode === 'SP') {
            if (+this.$route.query.updateProcessed === 2) {
              delete params.data.otherWareHouseSkus
              delete params.data.platformName
              res = await API.publishGetStoreEdit(params)
            } else res = await API.publishGetStoreAdd(params)
          } else if (this.getDetailParams.platformCode === 'SL') {
            if (+this.$route.query.updateProcessed === 2) {
              delete params.data.otherWareHouseSkus
              delete params.data.platformName
              res = await API.shoplineEdit(params)
            } else res = await API.shoplineAdd(params)
          } else if (this.getDetailParams.platformCode === 'WC') {
            if (+this.$route.query.updateProcessed === 2) {
              delete params.data.otherWareHouseSkus
              delete params.data.platformName
              res = await API.WoocommerceEdit(params)
            } else res = await API.WoocommerceAdd(params)
          } else if (this.getDetailParams.platformCode === 'TT') {
            if (+this.$route.query.updateProcessed === 2) {
              delete params.data.otherWareHouseSkus
              delete params.data.platformName
              res = await API.tiktokEdit(params)
            } else res = await API.tiktokAdd(params)
          }
          if (res.code === 10000) {
            this.$message.success(res.message)
            this.$router.push({
              path: '/publish/listings',
              query: {
                activeName: 'ListingQueue',
                platformCode: this.getDetailParams.platformCode
              }
            })
          } else if (res.code === 220011 && this.getDetailParams.platformCode !== 'WC') {
            this.$confirm(res.message, {
              type: 'warning'
            }).then(() => {
              this.listNowClick(true)
            })
          } else {
            this.$message.error(res.message)
          }
        } catch (err) {
          if (err.data.code === 10504 && this.getDetailParams.platformCode !== 'WC') {
            const that = this
            this.$confirm(this.$t('publishEdit.isFilterDuplicateSpuText'), {
              type: 'warning'
            }).then(() => {
              that.listNowClick(true)
            })
          } else if (err.data.code === 10504 && this.getDetailParams.platformCode === 'WC') {
            // this.$alert(this.$t('publishEdit.beenListed'), 'fail', {
            //   callback: action => {
            //     this.$message({
            //       type: 'error',
            //       message: `action: ${action}`
            //     })
            //   }
            // })
            // let message = err.data.message
            this.$message.error(this.$t('publishEdit.beenListed'))
          } else {
            let message = err.data.message
            this.$message.error(message)
          }
        }
        loading.close()
      } else {
        let res
        try {
          if (this.getDetailParams.platformCode === 'DJ') {
            res = await API.shoplazzaEdit(params)
          } else if (this.getDetailParams.platformCode === 'SP') {
            res = await API.publishGetStoreEdit(params)
          } else if (this.getDetailParams.platformCode === 'SL') {
            res = await API.shoplineEdit(params)
          } else if (this.getDetailParams.platformCode === 'WC') {
            res = await API.WoocommerceEdit(params)
          } else if (this.getDetailParams.platformCode === 'TT') {
            res = await API.tiktokEdit(params)
          }
          if (res.code === 10000) {
            this.$message.success(res.message)
            const router = {
              path: '/publish/listings',
              query: {
                activeName: (!params.data.productId && this.getDetailParams.platformCode === 'TT') ? 'ListingQueue' : undefined,
                platformCode: this.getDetailParams.platformCode
              }
            }
            this.$router.push(router)
          } else {
            this.$message.error(res.message)
          }
        } catch (err) {
          let message = err.message || err.data.message
          this.$message.error(message)
        }
        loading.close()
      }
    },
    changeImageUrl(imageUrl) {
      this.imageUrl = imageUrl
    },
    tabDecision() {
      let DescriptionIsEmpty = this.DescriptionIsEmpty()
      if (DescriptionIsEmpty) {
        this.radio1 = this.$t('Publish.Edit.Index.Description')
        return
      }
      let VariantsIsEmpty = this.VariantsIsEmpty()
      if (VariantsIsEmpty) {
        this.radio1 = this.$t('Publish.Edit.Index.Variants')
        return
      }
      let ImagesIsEmpty = this.ImagesIsEmpty()
      if (ImagesIsEmpty) {
        this.radio1 = this.$t('Publish.Edit.Index.Images')
        return
      }
      this.radio1 = this.$t('Publish.Edit.Index.Description')
    },
    DescriptionIsEmpty() {
      let empty = false
      if (!this.detailObj.bodyHtml) empty = true
      return empty
    },
    VariantsIsEmpty() {
      let empty = false
      let logistics = this.$refs.Variants.getlogistics()
      if (!Object.keys(logistics).length) empty = true
      return empty
    },
    ImagesIsEmpty() {
      let empty = this.imageList.every(e => !e.isChecked)
      return empty
    },
    sizeUnitChange(value) {
      if (!value.length) {
        this.sizeUnit = ['inch']
      }
      this.loadingFullscreen = this.$loading.service()
      let unit = this.sizeUnit.length > 1 ? 'inch,cm' : this.sizeUnit.join()
      API.productSizeContent({ kkProductId: this.detailObj.kkProductId, unit, image: this.getDetailParams.platformCode === 'TT' }).then(res => {
        if (this.getDetailParams.platformCode === 'TT') {
          this.$set(this.detailObj, 'sizeChartImageUrl', res.data.sizeContent)
          this.$set(this.detailObj, 'sizeChartImageId', undefined)
          this.$forceUpdate()// 强制更新视图
        } else this.detailObj.bodyHtml = this.bodyHtml + res.data.sizeContent
      }).finally(() => {
        this.loadingFullscreen.close()
      })
    },

    // TT获取仓库列表
    tiktokListingWarehouses() {
      API.tiktokListingWarehouses({
        storeId: this.$route.query.storeId
      }).then(res => {
        if (!res.data || !res.data.length) return
        this.detailObj.ttWarehouseList = res.data
        let variants = this.detailObj.variants
        if (variants && variants.length) {
          variants.forEach(item => {
            item.warehouseId = res.data.find(item => item.isDefault).warehouseId || undefined
          })
        }
      })
    },

    update() {
      sessionStorage.setItem('listingUpdateData', JSON.stringify({
        productId: this.detailObj.productId,
        listingId: this.detailObj.listingId,
        listingStatus: this.detailObj.listingStatus,
        id: this.detailObj.id,
        synTypeList: this.detailObj.productId ? [2] : [1],
        productType: this.detailObj.productType,
        tags: this.$refs.TopInfo.getTags()
      }))
      this.$router.replace({
        path: '/publish/edit',
        query: {
          kkProductId: this.detailObj.kkProductId,
          storeId: this.detailObj.storeId,
          storeName: this.detailObj.storeName,
          platformCode: this.$route.query.platformCode,
          platformName: this.$route.query.platformCode,
          updateProcessed: 2,
          productId: this.detailObj.productId
        }
      })
      this.$nextTick(() => {
        location.reload()
      })
    }
  },
  destroyed() {
    bus.$off('skuChangeImageHandle')
  }
}
</script>

<style scoped lang="scss">
[v-cloak] {
  display: none;
}
.top {
    .breadcrumb {
        margin: 8px 0 4px;
    }
    .ProductionEditor {
        font-size: 18px;
        font-weight: 500;
        height: 28px;
        line-height: 28px;
    }
    .buttonGroupTop {

    }
}
.edit {
    font-size: 14px;
}
.update-alert {
  background-color: #fdf6ec;
  width: calc(100vw - 214px);
  height: 36px;
  position: fixed;
  top: 40px;
  z-index: 9;
  left: 208px;
  padding: 20px;
  color: #FAB55A;

  i {
    font-size: 20px;
    color: #e6a23c;
  }
}
.buttonGroup {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #ffffff;
    padding: 12px 0;
    box-shadow: 0 3px 10px #888888;
    z-index: 10;
}
.requiredLabel::before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}

.redBorder {
  /deep/input{
    border-color: red;
    color: red;
  }
}
</style>
